var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Icon } from "../../../../../UI";
import { Translate } from "../../../../../I18N";
import { DisplayPills } from "./DisplayPills";

const TableTitle = ({ items = [], icon = 'user' }) => /*#__PURE__*/
_jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
_jsx("div", { className: "bg-indigo-200 size-[28px] justify-center items-center rounded-full flex" }, void 0, /*#__PURE__*/
_jsx(Icon, { className: "size-[20px]", icon: icon })
), /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(Translate, { className: "text-base font-semibold text-gray-900" }, void 0, "Paragraphs"), ' ', /*#__PURE__*/
_jsx(Translate, { className: "italic text-base text-gray-900" }, void 0, "for")
), /*#__PURE__*/
_jsx(DisplayPills, { items: items })
);


export { TableTitle };